import * as React from "react";

export const QuantityEditor: React.FunctionComponent<{
  quantity: number;
  setQuantity: (q: number) => void;
}> = ({ quantity, setQuantity }) => {
  return (
    <div className="quantity">
      <label htmlFor="txtQty" className="qty-label sr-only">
        Quantity:
      </label>
      <button
        type="button"
        aria-label="Decrease Quantity by 1"
        className="decrement"
        tabIndex={0}
        onClick={() => {
          if (quantity <= 1) {
            return;
          }
          setQuantity(quantity - 1);
        }}
      >
        <span className="h"></span>
      </button>
      <input
        type="number"
        value={quantity}
        onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
        maxLength={2}
        size={2}
        id="txtQty"
        className="textBoxStyle quantity-input totalQty"
      />
      <button
        type="button"
        aria-label="Increase Quantity by 1"
        className="increment"
        tabIndex={0}
        onClick={() => {
          if (quantity >= 99) {
            return;
          }
          setQuantity(quantity + 1);
        }}
      >
        <span className="h"></span>
        <span className="v"></span>
      </button>
    </div>
  );
};
